























import VueOptions from '@utils/VueOptions'
import UiList from '@superUI/List/List'

settings = 
  name: 'BrandSelector'
  components: { UiList }
  resources:
    brandSelector:
      slug: ':resourcePath'
      params:
        scope: ":scopes"
  vue:
    props: ['resourcePath', 'hiBrandSelected', 'brandId', 'scopes']
    data: ->
      selectedBrandId: null
      brands: []
      searchTimeout: null
      brandSearch: ''

    mounted: ->
      @fetchBrands('', @brandId)

    methods:
      fetchBrands: (q = '', brand_id) ->
        ctx = this
        params = {}
        params.page = 1
        params.q = q
        params.brand_id = brand_id if brand_id
        params.scopes = @scopes

        clearTimeout(@searchTimeout)
        @searchTimeout = setTimeout(() ->
          ctx.fetchWithoutStoring(ctx.resourcePath, params).then((result) ->
            ctx.brands = result
          )
        , 500)

    watch:
      brandSearch: (value) ->
        @fetchBrands(value, @brandId)

export default VueOptions.vue settings
